import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { constants } from '../../constants/constants';
import { DataShareService } from '../../services/DataShareService.service';
import { OktaService } from '../../services/okta.service';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  title = 'BatchRater';
  UserLoggedIn: boolean = false;
  Menus: any[] = [];
  UserFullName: string = '';
  Isvalid: boolean = true;
  IsConfirmation: boolean = false;
  redirectUrl: any;
  selectedIndex: any = 0;
  menuidx: any;
  FileInProgressMessage: any = constants.FileInProgressMessage;

  constructor(
    public authStateService: OktaAuthStateService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private oktaService: OktaService,
    private sessionService: SessionService,
    private router: Router,
    private DataShareService: DataShareService
  ) {
    this.DataShareService.HeaderComponent$.subscribe(res => {
      this.RanAsChangeMenu();
    });
  }

  ngOnInit(): void {
    this.oktaService.OktaAuthObject();
    this.oktaService.isUserLoggedIn.subscribe(value => {
      this.UserLoggedIn = value;

      if (this.UserLoggedIn) {
        this.DataShareService.setUserLogIn(this.UserLoggedIn);
        var data: any = this.sessionService.getLocalStorage('Menu');
        this.UserFullName =
          this.sessionService.getClaimFromToken('FirstName') +
          ' ' +
          this.sessionService.getClaimFromToken('LastName');
        this.Menus = JSON.parse(data);
        this.selectedIndex = this.Menus.findIndex(
          x =>
            x.path ==
            (location.pathname == '/auth' ? '/Rates' : location.pathname)
        );
      }
    });
  }

  logout(event: Event) {
    event.preventDefault();
    this.oktaService.logout();
  }
  OnPageLode(event: any, idx: any) {
    if (location.pathname == event) {
      return false;
    }
    let FileInProgress: any = localStorage.getItem(constants.FileInProgress);
    if (FileInProgress == 'true') {
      this.redirectUrl = event;
      this.menuidx = idx;
      this.IsConfirmation = true;
      return false;
    } else {
      this.selectedIndex = idx;
      this.router.navigateByUrl(event);
    }
  }
  cancelProcess() {
    this.IsConfirmation = false;
    return false;
  }
  continueRedirect() {
    this.IsConfirmation = false;
    this.selectedIndex = this.menuidx;
    localStorage.setItem(constants.FileInProgress, 'false');
    this.router.navigate([this.redirectUrl]);
  }
  RanAsChangeMenu() {
    this.selectedIndex = this.Menus.findIndex(x => x.path == location.pathname);
  }
}
